import { TOGGLE_MODAL, ENQUIRE, SET_SUBMITTED } from './constants';

export function toggleModal(visible) {
  return {
    type: TOGGLE_MODAL,
    payload: { visible },
  };
}

export function enquire({ values, form }) {
  return {
    type: ENQUIRE,
    payload: { values, form },
  };
}

export function setSubmitted(submitted) {
  return {
    type: SET_SUBMITTED,
    payload: { submitted },
  };
}



// WEBPACK FOOTER //
// ./app/javascript/pro_platform/components/EnquireModal/actions.js